import { useFormContext } from 'react-hook-form';

import { WallZoneFormData } from './types';

export const useWallFormContext = () => {
  return useFormContext<WallZoneFormData>();
};
